import React, { Component } from 'react'

import isEmpty from 'lodash/isEmpty'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'reactstrap'

import {
  getPracticeReportList,
  getPracticeReportSearch,
  emptyPracticeReportSearch,
} from '../../actions'
import ExportExcel from './exportExcel'
import PracticeReports from './practiceReports'
import PracticeReportsSearchBox from './practiceReportsSearchBox'

import './styles/style.scss'

class ReportDashboard extends Component {
  constructor(props) {
    super(props)

    this.state = {}
    this.props.emptyPracticeReportSearch()
    this.handleSearch = this.handleSearch.bind(this)
  }

  componentDidUpdate(nextProps) {
    if (
      nextProps.practiceReports.assignedMembers &&
      nextProps.practiceReports.assignedMembers.length > 0 &&
      this.props.practiceReports.assignedMembers !==
        nextProps.practiceReports.assignedMembers
    ) {
      if (this.props.practiceReports.searchText) {
        this.props.getPracticeReportSearch(
          this.props.practiceReports.searchText
        )
      }
    }
  }

  handleSearch(values) {
    if (
      this.props.practiceReports &&
      this.props.practiceReports.assignedMembers &&
      !isEmpty(values)
    ) {
      this.props.getPracticeReportSearch(values)
    } else {
      this.props.emptyPracticeReportSearch()
    }
  }

  render() {
    const { assignedMembers, searchreportList } = this.props.practiceReports

    return (
      <Container>
        <Row className="py-4 m-margin-left-1 flex flex-justify-space-between">
          <Col className="customColumn">
            <Link to={`/practice-reports/${this.props.match.params.taxId}`}>
              <span className="icon icon-arrow-left-blue reportBackIcon" />
            </Link>

            <h4 className="practice-report-label">Assigned Member Report</h4>
          </Col>
          <Col className="flex flex-justify-end">
            <span className="assignedMembersCount mx-3">
              {searchreportList
                ? searchreportList.length
                : assignedMembers.length}
              {' total member(s) assigned'}
            </span>
            <ExportExcel memberReportList={searchreportList || assignedMembers}>
              <span className="icon icon-export reportDownloadIcon" />
            </ExportExcel>
          </Col>
        </Row>
        <Row className="data-table-container">
          <PracticeReportsSearchBox
            handleSubmit={this.handleSearch}
            initialList={this.handleSearch}
            initialValues={this.props.practiceReports.searchText}
          />
          <PracticeReports
            memberSearchResults={searchreportList || assignedMembers}
            practiceReports={this.props.practiceReports}
          />
        </Row>
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  practiceReports: state.practiceReports,
})

const mapDispatchToProps = dispatch => ({
  getPracticeReportList: carePointObj =>
    dispatch(getPracticeReportList(carePointObj)),
  getPracticeReportSearch: value => dispatch(getPracticeReportSearch(value)),
  emptyPracticeReportSearch: () => dispatch(emptyPracticeReportSearch),
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReportDashboard)
)
